<template>
  <b-modal id="createUserDataEmployeeModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.userdataemployee.createUserDataEmployeeHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <UserDataEmployeeCreate :firmIRI="firmIRI"></UserDataEmployeeCreate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import UserDataEmployeeCreate from '../Create.vue'
export default {
  name: 'CreateUserDataEmployeeModal',
  components: {
    UserDataEmployeeCreate
  },
  computed: {
    show () {
      return this.$store.state.modals.userdataemployee.create.show
    },
    computedFirmIRI () {
      return this.$store.state.modals.userdataemployee.create.firmIRI
    },
    close () {
      return this.$store.state.modals.userdataemployee.create.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      firmIRI: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.computedFirmIRI) {
        this.firmIRI = this.$store.state.modals.userdataemployee.create.firmIRI
        this.$store.state.modals.userdataemployee.create.show = 0
        this.$store.state.modals.userdataemployee.create.firmIRI = null
        this.$bvModal.show('createUserDataEmployeeModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.userdataemployee.create.close = 0
        this.$bvModal.hide('createUserDataEmployeeModal')
      }
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
